import ProductHero from './ProductHero';
import formatPrismicData from '../../hocs/formatPrismicData';
import withProduct from '../../hocs/withProduct';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { findLowestVariantPrice } from 'src/common/utils/product';
import scrollTo from '../../utils/scrollTo';
import withMedia from '../../hocs/withMediaQueries';
import withCountry from '../../hocs/withCountry';
import { withModel } from '../../data-providers/model';

const enhance = compose(
  withCountry,
  withProduct,
  formatPrismicData,
  withState('isCarouselMediaPlaying', 'setIsCarouselMediaPlaying', false),
  withMedia,
  withModel,
  withProps(props => ({
    ...findLowestVariantPrice(props.product.variants, props.country),
    isNavigationDisabled: !!(props.isCarouselMediaPlaying || props.media.tabletUp),
    includeSchema: !props.model.prismicPageModel.hasTrustPilot,
  })),
  withHandlers({
    handleOnClick: () => () => scrollTo('#product-review-list-1'),
  }),
);

export default enhance(ProductHero);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductHero/index.js